import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
export const HeroSection = () => {
  return <section className="w-full bg-white py-16 sm:py-24 border-b border-gray-200" data-id="element-185">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-186">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-187">
          <div data-id="element-188">
            <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 leading-tight" data-id="element-189">
              Transform Your Enterprise with{' '}
              <span className="text-indigo-600" data-id="element-190">AI Integration</span>
            </h1>
            <p className="mt-6 text-xl text-gray-700 max-w-2xl" data-id="element-191">
              Seamlessly integrate AI across all verticals of your enterprise:
              HR, Finance, Accounting, Operations, and Vendor Management.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-4" data-id="element-192">
              <button className="bg-indigo-600 text-white px-6 py-3 rounded-md font-medium hover:bg-indigo-700 transition-colors shadow-md hover:shadow-lg" data-id="element-193">
                Get Started
              </button>
              <button className="flex items-center justify-center text-indigo-600 bg-white border-2 border-indigo-600 px-6 py-3 rounded-md font-medium hover:bg-indigo-50 transition-colors shadow-sm hover:shadow-md" data-id="element-194">
                Book a Demo <ChevronRightIcon size={18} className="ml-2" data-id="element-195" />
              </button>
            </div>
          </div>
          <div className="hidden lg:block" data-id="element-196">
            <div className="relative" data-id="element-197">
              <div className="absolute -left-8 -top-8 w-64 h-64 bg-indigo-100 rounded-full mix-blend-multiply opacity-50 animate-blob" data-id="element-198"></div>
              <div className="absolute -right-4 -bottom-8 w-64 h-64 bg-purple-100 rounded-full mix-blend-multiply opacity-50 animate-blob animation-delay-2000" data-id="element-199"></div>
              <div className="absolute top-8 left-20 bottom-12 w-64 h-64 bg-blue-100 rounded-full mix-blend-multiply opacity-50 animate-blob animation-delay-4000" data-id="element-200"></div>
              <div className="relative " data-id="element-201">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/moe53QNQ8XCnZSdUPn2G1f/Transform_With_Ai_Images.png" alt="AI network connecting people across the enterprise" className="rounded-lg shadow-2xl border border-gray-200" data-id="element-202" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};